import { AcceptJs } from "./types";
import { loadScript } from "./loader-core";

let acceptPromise: Promise<AcceptJs | null> | null;

/**
 * Manages the promises for loading Accept
 */
const getAcceptPromise: () => Promise<AcceptJs | null> = () => {
  if (acceptPromise) {
    return acceptPromise;
  }

  acceptPromise = loadScript(null).catch((error) => {
    // clear cache on error
    acceptPromise = null;
    return Promise.reject(error);
  });
  return acceptPromise;
};

export const loadAuthorize = async () => {
  return getAcceptPromise();
};
